<ng-container *transloco="let t">
  @if (storeName()) {
    <IAlert type="info" [title]="t('store-spotlight-pages.selected_store') + ' ' + storeName()" />
  }

  @if (!noAsinsFound) {
    <p class="type-label text-muted-foreground mt-3 mb-0">{{ t("store-spotlight-pages.asin_list_disclaimer") }}</p>

    <div
      class="cdk-boudary mt-4 flex flex-col divide-y rounded-md border border-gray-200 bg-white"
      cdkDropList
      (cdkDropListDropped)="drop($event)"
    >
      @for (asinControl of asinOrder; track asinControl; let i = $index) {
        <div cdkDrag cdkDragRootElement=".drag-item" cdkDragBoundary=".cdk-boudary" class="flex rounded-md bg-white">
          <div class="flex cursor-move flex-col items-center justify-between border-r p-1" cdkDragHandle>
            <IIcon name="dragVertical" class="text-3xl text-gray-400" />
            <span class="font-medium text-gray-500">{{ i + 1 }}</span>
            <IIcon name="dragVertical" class="text-3xl text-gray-400" />
          </div>
          <ng-template
            [ngTemplateOutlet]="productTemplate"
            [ngTemplateOutletContext]="{ p: asinControl, i }"
          ></ng-template>
        </div>
      }
    </div>
  } @else {
    <div class="relative mt-2 w-full overflow-hidden rounded-lg bg-orange-50 p-4 text-orange-500">
      <div class="tems-start flex gap-3">
        <IIcon name="alertCircle" class="size-5 shrink-0" />
        <div class="w-0 flex-1">
          <div class="mt-0 text-sm leading-5 opacity-90">
            {{ t("store-spotlight-pages.no_store_page") }}
          </div>
        </div>
      </div>
    </div>
  }

  <ng-template #productTemplate let-p="p" let-i="i">
    <div class="drag-item flex flex-1 flex-col rounded-md">
      <div class="flex items-center justify-between border-b px-2 py-1">
        @if (p.controls.storePage.value?.storePageUrl; as storePageUrl) {
          <a class="m-0 text-xs font-medium !text-blue-700 hover:underline" [href]="storePageUrl" target="_blank">
            {{ p.controls.storePage.value?.storePageName }}
          </a>
        } @else {
          <span class="m-0 text-xs font-medium">{{ p.controls.storePage.value?.storePageName }}</span>
        }

        <ISelectMenu
          [value]="p.controls.storePage.value"
          (valueChange)="changeStorePage(p, $event)"
          placement="bottom-end"
          [(searchQuery)]="storePageNameQuery"
        >
          <ISelectTrigger size="xs">
            {{ t("store-spotlight-pages.change_page") }}
          </ISelectTrigger>
          <ISelectContent>
            @for (s of queryFilteredStorePages(); track s.storePageId) {
              <ISelectOption [value]="s" [disabled]="!s.asinList?.length || isPageSelected(s)">{{
                s.storePageName
              }}</ISelectOption>
            }
          </ISelectContent>
        </ISelectMenu>
      </div>
      <div class="flex items-center gap-3 p-3">
        <div class="flex max-w-min flex-col gap-1">
          <div class="rounded-md border p-1">
            <app-product-thumbnail
              [iTooltip]="p.controls.asin.value"
              class="sensitive-data [&_img]:rounded-xs"
              [marketplace]="marketplace!"
              [asin]="p.controls.asin.value"
              customSizeClass="size-16"
            />
          </div>
          @if (p.controls.asin.value) {
            <p class="type-label text-muted-foreground m-0 truncate">{{ p.controls.asin.value }}</p>
          }
        </div>
        <div class="flex-1">
          <IFormField>
            <label iLabel>{{ t("common.title") }}</label>
            <input iInput [maxLength]="50" [formControl]="p.controls.title" />
          </IFormField>
          <button iButton variant="ghost" size="xs" class="mt-1" (click)="openAsinList(p)" type="button">
            <IIcon name="exchange" />
            {{ t("store-spotlight-pages.change_product") }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #asinModalTemplate>
    <div class="modal-body flex h-full flex-col p-0">
      <div class="border-b p-4">
        <h4 class="m-0 font-medium text-gray-700">
          {{ focusedStorePageName() }}
          <span class="font-normal text-gray-400">{{
            t("store-spotlight-pages.filter_found", { count: filteredAsinList().length })
          }}</span>
        </h4>
      </div>
      <div class="border-b p-4">
        <div iInputGroup>
          <IIcon name="search" />
          <input
            iInputGroupInput
            [ngModel]="asinQuery()"
            (ngModelChange)="asinQuery.set($event)"
            placeholder="{{ t('store-spotlight-pages.search_by_asin') }}"
            autocomplete="off"
            autofocus
          />
        </div>
      </div>
      <div class="min-h-0 flex-auto overflow-y-auto p-3">
        @for (a of filteredAsinList(); track a) {
          <div
            class="checkbox-card mb-1"
            [class.checkbox-card-selected]="isAsinSelectedForPage(a)"
            (click)="selectAsin(a)"
          >
            <div class="flex w-100 items-center justify-between">
              <app-product-thumbnail [asin]="a" [marketplace]="marketplace!" [smallImg]="true" />
              <div>{{ a }}</div>
              <div [class.checked]="isAsinSelectedForPage(a)" class="radio-btn shrink-0">
                <div></div>
              </div>
            </div>
          </div>
        } @empty {
          <div class="flex h-full items-center justify-center">
            <p class="m-0 text-gray-500">{{ t("store-spotlight-pages.no_products_found") }}</p>
          </div>
        }
      </div>
      <div class="flex shrink-0 justify-end !border-t p-4">
        <button iButton variant="secondary" size="md" (click)="storeAsinModal && storeAsinModal.close()">
          {{ t("common.close") }}
        </button>
      </div>
    </div>
  </ng-template>
</ng-container>
